<template>
  <div
    @drag.prevent.stop="drag"
    @dragstart.prevent.stop="dragStart"
    @dragend.prevent.stop="dragEnd"
    @dragover.prevent.stop="dragOver"
    @dragenter.prevent.stop="dragEnter"
    @dragleave.prevent.stop="dragLeave"
    @drop.prevent.stop="drop">
    <slot />
  </div>
</template>
<script>
export function checkDnDSupport() {
  const div = document.createElement('div');
  const ret = (
    ('draggable' in div) ||
    ('ondragstart' in div && 'ondrop' in div)
  ) && 'FormData' in window && 'FileReader' in window;
  return ret;
}

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    overClass: {
      type: String,
      default: 'bg-warning'
    },

    draggingClass: {
      type: String,
      default: 'dragging'
    },
  },

  created() {
    this.advancedUpload = checkDnDSupport();
  },

  methods: {
    drag(/*e*/) {
      /*
      if (!this.disabled && this.advancedUpload) {

      }
      */
    },

    dragStart(/*e*/) {
      /*
      if (!this.disabled && this.advancedUpload) {

      }
      */
    },

    dragEnd(/*e*/) {
      if (!this.disabled && this.advancedUpload) {
        this.$el.classList.remove(this.overClass);
        this.$el.classList.remove(this.draggingClass);
      }
    },

    dragOver(/*e*/) {
      if (!this.disabled && this.advancedUpload) {
        this.$el.classList.add(this.overClass);
        this.$el.classList.add(this.draggingClass);
      }
    },

    dragEnter(/*e*/) {
      if (!this.disabled && this.advancedUpload) {
        this.$el.classList.add(this.overClass);
        this.$el.classList.add(this.draggingClass);
      }
    },

    dragLeave(/*e*/) {
      if (!this.disabled && this.advancedUpload) {
        this.$el.classList.remove(this.overClass);
        this.$el.classList.remove(this.draggingClass);
      }
    },

    drop(e) {
      if (!this.disabled && this.advancedUpload) {
        this.$el.classList.remove(this.overClass);
        this.$el.classList.remove(this.draggingClass);

        // console.log("DROP", e);
        const entries = [ ...e.dataTransfer.items ]
            .map(x => x.webkitGetAsEntry());
        console.log('Dropped entries', entries);
        this.$emit('drop', entries);
      }
    }
  }
};
</script>
